export const common = {
    en: {
        viewAll: 'View All',
        select: 'Select',
        all: 'All',
        search: 'Search',
        cancel: 'Cancel',
        reset: 'Reset',
        logo: 'Logo',
        menu: 'Menu',
        export: 'Export',
        logout: 'Logout',
        selectAll: 'Select all',
        deselectAll: 'Deselect all',
        from: 'From',
        to: 'To',
        close: 'Close',
        ok: 'Ok',
    },
};
